import React, { useState, useEffect } from "react";
import { FaWhatsapp, FaTimes } from "react-icons/fa";

export default function WhatsAppWidget() {
  const [visible, setVisible] = useState(false);
  const [open, setOpen] = useState(false);

  // Config — super admin can set this via settings (stored in localStorage for now)
  const whatsappNumber = localStorage.getItem("wa_number") || "2347076207734";
  const welcomeMessage = localStorage.getItem("wa_message") || "Hello! I need help with my UCH Self Service account.";
  const enabled = localStorage.getItem("wa_enabled") !== "false";

  useEffect(() => {
    const timer = setTimeout(() => setVisible(true), 3000);
    return () => clearTimeout(timer);
  }, []);

  if (!enabled || !visible) return null;

  const waUrl = `https://wa.me/${whatsappNumber}?text=${encodeURIComponent(welcomeMessage)}`;

  return (
    <div className="fixed bottom-6 right-6 z-[9998] flex flex-col items-end gap-3">
      {open && (
        <div className="bg-white rounded-2xl shadow-2xl border border-gray-100 w-72 overflow-hidden">
          <div className="bg-green-600 px-4 py-3 flex items-center justify-between">
            <div className="flex items-center gap-2">
              <FaWhatsapp className="text-white w-5 h-5" />
              <div>
                <p className="text-white font-bold text-sm">UCH Support</p>
                <p className="text-green-100 text-xs">Typically replies instantly</p>
              </div>
            </div>
            <button onClick={() => setOpen(false)} className="text-white/70 hover:text-white">
              <FaTimes />
            </button>
          </div>
          <div className="p-4 bg-green-50">
            <div className="bg-white rounded-xl rounded-tl-none p-3 shadow-sm text-sm text-gray-700 inline-block max-w-[90%]">
              👋 Hi! Need help with your UCH Self Service account? Click below to chat with us on WhatsApp — we're available <strong>24/7</strong>.
            </div>
          </div>
          <div className="p-4">
            <a href={waUrl} target="_blank" rel="noopener noreferrer"
              className="flex items-center justify-center gap-2 bg-green-600 hover:bg-green-700 text-white font-semibold py-3 rounded-xl text-sm w-full transition">
              <FaWhatsapp className="w-4 h-4" /> Start Chat
            </a>
          </div>
        </div>
      )}
      <button
        onClick={() => setOpen(o => !o)}
        className="w-14 h-14 bg-green-500 hover:bg-green-600 text-white rounded-full shadow-lg flex items-center justify-center transition-all hover:scale-105"
        aria-label="Chat on WhatsApp"
      >
        {open ? <FaTimes className="w-5 h-5" /> : <FaWhatsapp className="w-7 h-7" />}
      </button>
    </div>
  );
}
